import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ActionButton from '../ui/ActionButton';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  content: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'danger'
    | 'ghost'
    | 'success';
  cancelVariant?:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'danger'
    | 'ghost'
    | 'success';
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  content,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  cancelVariant = 'outline',
  onConfirm,
  onCancel,
  loading = false,
  maxWidth = 'xs',
}) => {
  const handleConfirm = () => {
    if (!loading) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (!loading) {
      onCancel();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" component="div" fontWeight={600}>
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {typeof content === 'string' ? (
          <Typography variant="body1" color="text.secondary">
            {content}
          </Typography>
        ) : (
          content
        )}
      </DialogContent>

      <DialogActions>
        <ActionButton
          variant={cancelVariant}
          size="md"
          onClick={handleCancel}
          disabled={loading}
        >
          {cancelText}
        </ActionButton>
        <ActionButton
          variant={confirmVariant}
          size="md"
          onClick={handleConfirm}
          loading={loading}
        >
          {confirmText}
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
